import { _fetch as fetchSecure } from '@hobs/utils/fetch';

export const Download = (blob, fileName) => {
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // MSIE
    window.navigator.msSaveOrOpenBlob(blob, fileName);
  } else {
    // Modern browsers
    const url = window.URL.createObjectURL(new Blob([blob]));
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    // we need to append the element to the
    // dom -> otherwise it will not work in firefox
    document.body.appendChild(a);
    a.click();
    a.remove(); //afterwards we remove the element again
  }
};

export const GetAttachmentData = async attachmentId => {
  const attachment = await fetchSecure(`Attachments/${attachmentId}`, {
    forceBlob: true
  });
  return attachment;
};
